export const hasMediaAccess = () => !!navigator.mediaDevices;
export const canQueryPermissions = () => !!navigator.permissions?.query;
export const getUserMedia = (
  ...args: Parameters<typeof navigator.mediaDevices.getUserMedia>
) => navigator.mediaDevices?.getUserMedia(...args);
